const colors = {
    ink: 'var(--colmeia-ink)',
    muted: 'var(--colmeia-muted)',
    border: 'var(--colmeia-border)',
    surface: 'var(--colmeia-surface)',
    field: 'var(--colmeia-surface-soft)',
    primary: 'var(--primary)',
    primaryHover: 'var(--primary-hover)',
};

const baseSelectStyles = {
    control: (base, state) => ({
        ...base,
        minHeight: 44,
        color: colors.ink,
        backgroundColor: colors.field,
        borderColor: state.isFocused ? colors.primary : colors.border,
        borderRadius: 12,
        boxShadow: state.isFocused ? '0 0 0 3px rgba(252, 128, 25, 0.13)' : 'none',
        opacity: state.isDisabled ? 0.68 : 1,
        cursor: state.isDisabled ? 'not-allowed' : 'default',
        ':hover': {
            borderColor: state.isDisabled ? colors.border : colors.primary,
        },
    }),
    valueContainer: (base) => ({ ...base, color: colors.ink }),
    singleValue: (base) => ({ ...base, color: colors.ink }),
    input: (base) => ({ ...base, color: colors.ink }),
    placeholder: (base) => ({ ...base, color: colors.muted, opacity: 0.78 }),
    dropdownIndicator: (base, state) => ({
        ...base,
        color: state.isFocused ? colors.primary : colors.muted,
        ':hover': { color: colors.primary },
    }),
    clearIndicator: (base) => ({
        ...base,
        color: colors.muted,
        ':hover': { color: colors.primary },
    }),
    indicatorSeparator: (base) => ({ ...base, backgroundColor: colors.border }),
    menu: (base) => ({
        ...base,
        overflow: 'hidden',
        color: colors.ink,
        backgroundColor: colors.surface,
        border: `1px solid ${colors.border}`,
        borderRadius: 12,
        boxShadow: '0 18px 40px rgba(0, 0, 0, 0.22)',
    }),
    menuList: (base) => ({ ...base, padding: 6, backgroundColor: colors.surface }),
    option: (base, state) => ({
        ...base,
        color: state.isSelected ? '#ffffff' : colors.ink,
        backgroundColor: state.isSelected
            ? colors.primary
            : state.isFocused ? 'rgba(252, 128, 25, 0.12)' : colors.surface,
        borderRadius: 8,
        cursor: 'pointer',
        ':active': {
            backgroundColor: state.isSelected ? colors.primaryHover : 'rgba(252, 128, 25, 0.2)',
        },
    }),
    multiValue: (base) => ({
        ...base,
        backgroundColor: 'rgba(252, 128, 25, 0.14)',
        borderRadius: 7,
    }),
    multiValueLabel: (base) => ({ ...base, color: colors.ink }),
    multiValueRemove: (base) => ({
        ...base,
        color: colors.primary,
        ':hover': { color: '#ffffff', backgroundColor: colors.primary },
    }),
    // Alguns fluxos, como o painel lateral do agendamento rápido, ficam acima
    // dos overlays comuns da aplicação (z-index 20001). O menu é portado para
    // o body e precisa superar essa camada para as opções continuarem visíveis.
    menuPortal: (base) => ({ ...base, zIndex: 30000 }),
};

/**
 * Compõe ajustes específicos de um select sobre o tema compartilhado sem
 * descartar cores, foco e demais estados definidos para toda a aplicação.
 */
export const createSelectStyles = (overrides = {}) => {
    const styleKeys = new Set([...Object.keys(baseSelectStyles), ...Object.keys(overrides)]);

    return Array.from(styleKeys).reduce((styles, key) => {
        const baseStyle = baseSelectStyles[key];
        const overrideStyle = overrides[key];

        if (baseStyle && overrideStyle) {
            styles[key] = (provided, state) => overrideStyle(baseStyle(provided, state), state);
        } else {
            styles[key] = overrideStyle || baseStyle;
        }

        return styles;
    }, {});
};

export const selectThemeProps = {
    className: 'custom-react-select',
    classNamePrefix: 'react-select',
    menuPosition: 'fixed',
};

export const getSelectMenuPortalTarget = () => (
    typeof document !== 'undefined' ? document.body : null
);
